import { Map } from 'immutable'
import { SET_CONFIG_DATA, SET_CONFIG_PROCESSING } from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CONFIG_PROCESSING:
      return state.set('processing', action.payload)
    case SET_CONFIG_DATA:
      return state.merge(Map({
        data: action.payload.data,
        processing: action.payload.processing,
      }))
    default:
      return state
  }
}
